import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=347d65ec&scoped=true&"
import script from "./ScrollTop.vue?vue&type=script&lang=ts&"
export * from "./ScrollTop.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollTop.vue?vue&type=style&index=0&id=347d65ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d65ec",
  null
  
)

export default component.exports